import { useContext } from "react";
import VueContext from "./vueContext";
import { Features } from "@iloq/shared/IRootState";
import { isFeatureEnabled } from "@iloq/shared/is-feature-enabled";

export function useIsFeatureEnabled(
  feature: keyof Features,
  /* By default feature flags must be defined as false to disable a feature,
   * but that can be switched by specifically setting defaultEnabled to false,
   * in which case missing flag -> disabled feature. */
  defaultEnabled = true,
): boolean {
  const { $store } = useContext(VueContext);
  return isFeatureEnabled({ feature, featureFlags: $store?.state?.features, defaultEnabled });
}
